// extracted by css-extract-rspack-plugin
export default {"header":"header-lEJ4Mg","title":"title-l2gL6V","subtitle":"subtitle-c8SbXg"};